import React from "react";
import { Box } from "@chakra-ui/react";
import { Text } from "./text";
const colorByVariant = {
    success: "green.600",
    error: "red.600",
    processing: "blue.600",
    warning: "yellow.500",
    inactive: "gray.400",
};
export function StatusIndicator({ variant, children, ...props }) {
    return (React.createElement(Box, { display: "inline-flex", alignItems: "center", gap: 2, ...props },
        React.createElement(Box, { flex: "none", boxSize: 2, borderRadius: "full", bg: colorByVariant[variant], className: "chakra-status-indicator-light" }),
        React.createElement(Text, null, children)));
}
